// extracted by mini-css-extract-plugin
export default {"root":"CompManage_root__mu1BC"};